import React from 'react';
import PropTypes from 'prop-types';
import { Divider, Alert, Button } from 'antd';
import { PlusCircleOutlined, MinusCircleOutlined } from '@ant-design/icons';
import { Form as FormikForm } from 'formik-antd';
import { FieldArray } from 'formik';
import { LayoutGrid } from 'components/layouts';
import { Fieldset } from 'components/form';
import mandatoryCourses from 'utils/mandatory-courses';
import StagePropTypes from './prop-types';
import CourseInput from './course-input';
import { DB_PREFIX_EXTRA, DB_PREFIX_MANDATORY } from './constants';

const Form = ({ isSubmitting, setFieldValue, uploadTo, values, children }) => {
  return (
    <FormikForm layout="vertical">
      <Alert
        message="Courses details"
        description="Add details of courses undertaken/attended in the last twelve months and that are relevant to the role you are registering for. These will need to be authenticated by a minimum 'proof of attendance' certificate. If you upload a document to the wrong section, simply click on the ‘Upload new’ button again and it will delete it for you."
        type="info"
        showIcon
      />

      <h2>Mandatory Courses</h2>

      <LayoutGrid>
        {mandatoryCourses.map(({ name, label }) => {
          return (
            <CourseInput
              key={name}
              label={label}
              name={name}
              dbPrefix={DB_PREFIX_MANDATORY}
              isSubmitting={isSubmitting}
              values={values}
              setFieldValue={setFieldValue}
              uploadTo={uploadTo}
              showLabel
            />
          );
        })}
      </LayoutGrid>

      <Divider />

      <h2>Additional Courses</h2>

      <FieldArray
        name={DB_PREFIX_EXTRA}
        render={(arrayHelpers) => (
          <>
            {values[DB_PREFIX_EXTRA].map((course, i) => {
              return (
                <React.Fragment key={i}>
                  <div>
                    <CourseInput
                      name={`${i}`}
                      dbPrefix={DB_PREFIX_EXTRA}
                      isSubmitting={isSubmitting}
                      values={values}
                      setFieldValue={setFieldValue}
                      uploadTo={uploadTo}
                    />

                    <Fieldset>
                      <Button
                        type="danger"
                        className="dynamic-delete-button"
                        onClick={() => arrayHelpers.remove(i)}
                      >
                        <MinusCircleOutlined className="dynamic-delete-button" />
                        Delete
                      </Button>
                    </Fieldset>
                    {/* {i === values[DB_PREFIX_EXTRA].length - 1 ? null : (
                      <Divider />
                    )} */}
                  </div>

                  <Divider />

                  <Fieldset>
                    {i === values[DB_PREFIX_EXTRA].length - 1 ? (
                      <Button
                        style={{ width: '100%' }}
                        type="dashed"
                        onClick={() =>
                          arrayHelpers.push({
                            name: '',
                            date: null,
                            fileURL: '',
                          })
                        }
                      >
                        <PlusCircleOutlined /> Add course
                      </Button>
                    ) : null}
                  </Fieldset>
                </React.Fragment>
              );
            })}

            {values[DB_PREFIX_EXTRA].length === 0 ? (
              <Fieldset>
                <Button
                  style={{ width: '100%' }}
                  type="dashed"
                  onClick={() =>
                    arrayHelpers.push({
                      name: '',
                      date: null,
                      fileURL: '',
                    })
                  }
                >
                  <PlusCircleOutlined /> Add course
                </Button>
              </Fieldset>
            ) : null}
          </>
        )}
      />

      {children}
    </FormikForm>
  );
};

Form.propTypes = {
  children: PropTypes.node,
  isSubmitting: PropTypes.bool,
  values: StagePropTypes.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  uploadTo: PropTypes.string.isRequired,
};

Form.defaultProps = {
  children: null,
  isSubmitting: false,
};

export default Form;
